import { useForm } from 'react-hook-form'
import { useQueryClient } from '@tanstack/react-query'
import { Button, Dialog } from 'vnetwork-ui'
import {
    getTicketSelectOptions,
    linkedTicketByID,
} from '@/modules/Ticket/services'
import { useTranslation } from 'react-i18next'
import AsyncSelectWithServer from '@/components/Form/Shared/AsyncSelectWithServer'
import useDataGridRefetch from '@/hooks/useDataGridRefetch'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface LinkTicketProps {
    open: boolean
    onClose: () => void
    ticket: any
}

interface FormValues {
    ticket_groups: string[]
}

const LinkTicket: React.FC<LinkTicketProps> = ({ open, onClose, ticket }) => {
    const queryClient = useQueryClient()
    const { t } = useTranslation()
    const { refetchAll: refetchLogs } = useDataGridRefetch({
        reactQueryKey: `ticket-logs-${ticket?.ticket_id}`,
    })
    const { control, handleSubmit } = useForm<FormValues>({
        defaultValues: {
            ticket_groups: ticket?.ticket_groups || [],
        },
    })

    const { mutateAsync: linkedTicketMutation, isPending } =
        useMutationWithHandler(
            { mutationFn: linkedTicketByID },
            {
                reactQueryKeys: QUERY_KEYS.TICKETS,
                successMessage: t('updated-success'),
                onSuccess: () => {
                    queryClient.invalidateQueries({
                        queryKey: [
                            QUERY_KEYS.TICKET_DETAIL,
                            String(ticket.ticket_id),
                        ],
                    })
                    refetchLogs()
                    onClose()
                },
            }
        )

    const onSubmit = async (values: FormValues) => {
        await linkedTicketMutation({
            ticket_id: ticket.ticket_id,
            ticket_groups: values.ticket_groups,
        })
    }
    console.log('ticket', ticket.ticket_id)
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            title={t('ticket-link-title')}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <AsyncSelectWithServer
                    asyncOptions={getTicketSelectOptions(
                        ticket?.ticket_id,
                        ticket?.ticket_groups || []
                    )}
                    name="ticket_groups"
                    control={control}
                    label={t('ticket-link-type')}
                    placeholder={t('ticket-link-type')}
                    className="mt-2"
                    multiple
                />
                <div className="flex justify-end mt-4 gap-4">
                    <Button size="small" variant="outlined" onClick={onClose}>
                        {t('cancle-operation')}
                    </Button>
                    <Button
                        variant="contained"
                        type="submit"
                        loading={isPending}
                        onClick={handleSubmit(onSubmit)}
                    >
                        {t('ticket-link-create')}
                    </Button>
                </div>
            </form>
        </Dialog>
    )
}

export default LinkTicket
